// The API/SDK token-link params that ARE the session: `token` is the bearer (read from the live URL on
// every request, see main.tsx), `lang` drives i18n, `clientId`/`ref` scope the embed. The router keeps
// them across CLIENT navigations via `retainSearchParams` (see __root), but a HARD redirect
// (`window.location`) re-initializes the app from the new URL — so the test-gate / auth redirects must
// carry these forward by hand or the token-bearer is logged out (e.g. opening `/report?token=…` for an
// applicant who hasn't finished the test bounced to a bare `/test/competences`, dropping the session).
const SDK_PARAMS = ['token', 'lang', 'clientId', 'ref'] as const

// Append the current URL's SDK params to a same-origin redirect target (never overriding ones the target
// already sets). `path` may include a query/hash; returns a path string for `window.location`.
export function withSdkParams(path: string): string {
  if (typeof window === 'undefined') return path
  const url = new URL(path, window.location.origin)
  const current = new URLSearchParams(window.location.search)
  for (const key of SDK_PARAMS) {
    const value = current.get(key)
    if (value && !url.searchParams.has(key)) url.searchParams.set(key, value)
  }
  return `${url.pathname}${url.search}${url.hash}`
}
